"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTest = useTest;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var slugify = function slugify(string) {
  var _string$toString, _string$toString$toLo, _string$toString$toLo2, _string$toString$toLo3, _string$toString$toLo4, _string$toString$toLo5, _string$toString$toLo6, _string$toString$toLo7, _string$toString$toLo8;
  var a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;';
  var b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------';
  var p = new RegExp(a.split('').join('|'), 'g');
  return string === null || string === void 0 ? void 0 : (_string$toString = string.toString()) === null || _string$toString === void 0 ? void 0 : (_string$toString$toLo = _string$toString.toLowerCase()) === null || _string$toString$toLo === void 0 ? void 0 : (_string$toString$toLo2 = _string$toString$toLo.replace(/\s+/g, '-')) === null || _string$toString$toLo2 === void 0 ? void 0 : (_string$toString$toLo3 = _string$toString$toLo2.replace(p, function (c) {
    return b.charAt(a.indexOf(c));
  })) === null || _string$toString$toLo3 === void 0 ? void 0 : (_string$toString$toLo4 = _string$toString$toLo3.replace(/&/g, '-and-')) === null || _string$toString$toLo4 === void 0 ? void 0 : (_string$toString$toLo5 = _string$toString$toLo4.replace(/[\W"-\s]+/g, '')) === null || _string$toString$toLo5 === void 0 ? void 0 : (_string$toString$toLo6 = _string$toString$toLo5.replace(/-+/gi, '-')) === null || _string$toString$toLo6 === void 0 ? void 0 : (_string$toString$toLo7 = _string$toString$toLo6.replace(/^-+/, '')) === null || _string$toString$toLo7 === void 0 ? void 0 : (_string$toString$toLo8 = _string$toString$toLo7.replace(/-+$/, '')) === null || _string$toString$toLo8 === void 0 ? void 0 : _string$toString$toLo8.replace(/["']/g, '-');
};
/**
 * Generates test-id for checkout elements
 * @return {(elementCategory: string, elementName: string) => string} Returns data-testid string
 */

function useTest() {
  var isMobile = (0, _core.useMediaQuery)('(max-width:1024px)');
  var generateTestId = (0, _react.useCallback)(function (elementCategory, elementName) {
    if (elementName) {
      return "".concat(isMobile ? 'mobile-' : 'desktop-').concat(slugify(elementCategory), "-").concat(slugify(elementName));
    }
    return "".concat(isMobile ? 'mobile-' : 'desktop-').concat(slugify(elementCategory), "}");
  }, [isMobile]);
  return {
    generateTestId: generateTestId
  };
}